export default __webpack_public_path__ + "static/media/bx-chevron-down.a448b06e.svg";